/**
 * LanguageContext
 * 
 * 管理語言設定的 Context
 */

import React, { createContext, useContext, useState, useEffect } from 'react';
import { getItem, setItem } from '../utils/localStorage';

const LanguageContext = createContext(null);

const STORAGE_KEY = 'savedLanguage';
const DEFAULT_LANGUAGE = 'tc';

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return getItem(STORAGE_KEY, DEFAULT_LANGUAGE);
  });

  useEffect(() => {
    setItem(STORAGE_KEY, language);
  }, [language]);

  const changeLanguage = (lang) => {
    if (lang === 'tc' || lang === 'en') {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

